import styled from 'styled-components';
import { StockModelPageStyled } from '../StockModelPageStyled';

export const StockModelPageStyledAC = styled(StockModelPageStyled)`
    svg {
        path {
            fill: ${({ theme }) => theme.colors.blue2};
        }
    }
`;
